
$.widget('ui.agDropDown',
    {
        options: {

            // general
            insertEmptyItem: true,

            // used for initial value display
            initialDataSource: null,
            initialSelectedItem: null
        },

        _create: function() {
            var base = this;
            var $element = this.element;
            var $input = $element.find('input');
            this._$input = $input;

            // get the validation attributes, to reapply them after ig initialization
            var attributes = $input.clone()[0].attributes;
            var name = $input.attr('name');

            // filter initial data source
            if (this.options.initialDataSource)
                var initialSelectedItem = this.options.initialSelectedItem;
                this.options.initialDataSource = this.options.initialDataSource.filter(function(item) {
                    return !item.IsDiscontinued || item.Id === initialSelectedItem;
                });

            // init the igCombo
            $input.igCombo({
                virtualization: true,
                valueKey: 'Id',
                textKey: 'Name',
                mode: 'dropdown',
                dataSource: this.options.initialDataSource,
                initialSelectedItems: [{ value: this.options.initialSelectedItem }],
                itemTemplate: '<span class="dropdown-item" title="${Name}">${Name}</span>',
                selectionChanged: function () {
                    $element.closest('.ag-field').trigger('change.ag.field');
                    $element.closest('.ag-field').trigger('change_ag_field');

                    // set title to dropdown to contain selected text
                    $element.closest('.ag-field').find('[data-agex]').prop('title', $input.igCombo('text'));
                },
                autoSelectFirstMatch: false,
                allowCustomValue: false
            });

            // reapply attributes
            var $inputNew = $element.find('input[name="' + name + '"]');
            $.each(attributes, function (index, value) {
                if (value && value.name && value.name.startsWith('data-')) {
                    $input.removeAttr(value.name);
                    $inputNew.attr(value.name, value.value);
                }
            });
            $inputNew.addClass('validate-hidden');

            // move the id of input to the hidden value field to maintain compatibility with legacy non-igCombo dropdown usages.
            var id = $input.attr('id');
            $input.removeAttr('id');
            $inputNew.attr('id', id);

            // init the agField
            $element.closest('.ag-field')
                .agField({
                    getValue: function () {
                        return $input.igCombo('value');
                    },
                    setValue: function(value) {
                        $input.igCombo('value', value);
                    },
                    setElementData: function (value) {

                        // load new code list items
                        if (value.CodeListItems !== undefined) {
                            let selectedValue;

                            if (value.Value !== undefined && value.Value.Id !== undefined)
                                selectedValue = value.Value.Id;
                            else
                                selectedValue = $input.igCombo('value');

                            // filter code list items
                            let codeListItems = value.CodeListItems.filter(function(item) {
                                return !item.IsDiscontinued || item.Id === selectedValue;
                            });

                            // remember currently selected field
                            var currentlySelected = $input.igCombo("selectedItems");

                            if (base.options.insertEmptyItem)
                                codeListItems.splice(0, 0, { Id: '', Name: ''});

                            $input.igCombo("option", "dataSource", codeListItems);

                            // check if previously selected is in new data and select it
                            if (currentlySelected && currentlySelected.length > 0 && currentlySelected[0].data)
                                $input.igCombo('value', currentlySelected[0].data.Id);
                        }

                        // select new selected item
                        if (value.Value !== undefined && value.Value.Id !== undefined) {
                            $input.igCombo('value', value.Value.Id);

                            $input.closest('.ag-field').trigger('change.ag.field');
                            $input.closest('.ag-field').trigger('change_ag_field');
                        }
                    }
                });
        }
    });